import { EmailFormat } from './EmailFormat';
export default EmailFormat;
